import { Voucher } from '@/app/shared/interface/voucher.interface';
import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output, PLATFORM_ID, SimpleChanges, TemplateRef, ViewChild, OnChanges } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { VoucherDetailModalComponent } from './voucher-detail-modal/voucher-detail-modal.component';
import { VoucherService } from '@/app/shared/services/voucher.service';
import {Cart, CartItem} from '@/app/shared/interface/cart.interface';
import {CartService} from "@/app/shared/services/cart.service";
import {forkJoin} from "rxjs";
import {Router} from "@angular/router";
import {CommonService} from "@/app/shared/services/common.service";

@Component({
  selector: 'app-voucher-modal',
  templateUrl: './voucher-modal.component.html',
  styleUrl: './voucher-modal.component.scss'
})
export class VoucherModalComponent implements OnChanges {

  @ViewChild("voucherModal", { static: false }) voucherModal: TemplateRef<any>;
  
  @Input() vouchers: Voucher[] = [];
  @Input() cart: Cart;
  @Input() appliedVouchers: Voucher[] = [];
  @Input() isInCartPage = true;
  @Input() selectedCode: string[] = [];

  @Output() confirmed: EventEmitter<boolean> = new EventEmitter();
  @Output() useVoucher: EventEmitter<Voucher> = new EventEmitter();

  public closeResult: string;
  public modalOpen: boolean = false;

  selectedVoucher: Voucher;
  appLoader: boolean = false;

  params: any;

  constructor(
    private modalService: NgbModal,
    private toastService: ToastrService,
    private voucherService: VoucherService,
    private cartService : CartService,
    private commonService: CommonService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cart'] && !changes['cart'].firstChange) {
      this.getVouchers(this.params); // cập nhật lại danh sách voucher đang được áp dụng
    }
  }

  ngOnInit() {
  }

  async openModal() {
    if (isPlatformBrowser(this.platformId)) { // For SSR
      this.modalOpen = true;
      let modal = this.modalService.open(this.voucherModal, {
        ariaLabelledBy: 'Voucher-Modal',
        centered: true,
        windowClass: 'theme-modal modal-lg voucher-modal',
      });

      modal.shown.subscribe(() => {
        this.vouchers = [];
        this.getVouchers();
      });

      modal.result.then((result) => {
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        // this.vouchers = [];
        this.confirm(false);
      });
    }
  }

  private getDismissReason(reason: ModalDismissReasons): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  confirm(value: boolean) {
    this.confirmed.emit(value);
    this.modalService.dismissAll();
  }

  copyToClipboard(voucher: Voucher) {
    if (isPlatformBrowser(this.platformId)) {
      navigator.clipboard.writeText(voucher.code);
    }
    this.toastService.success("Sao chép mã giảm giá thành công!", "", { positionClass: "toast-top-right" });
  }

  applyVoucher(voucher: Voucher) {

    this.useVoucher.emit(voucher)

        // if (this.modalOpen) {
        //   this.modalService.dismissAll();
        // }
  }
  validateVoucherUnitUsage(event: any, voucher: Voucher) {
    let val = event.target.value;

    if (val < 1) {
      event.target.value = 1;
    }

    if (val > voucher.remainingUses) {
      event.target.value = voucher.remainingUses;
    }

    voucher.unitsUsed = Number(event.target.value);
  }

getVouchers(body?: any) {
  this.appLoader = true;
  this.voucherService.getApplicableVouchers(body).subscribe({
    next: (res: any) => {
      this.vouchers = (res ?? []).map((x: any) => {
        const isApplied = this.cart?.appliedVouchers?.some((applied: any) => applied.id === x.id);
        return {
          ...x,
          unitsUsed: x.remainingUses,
          isApplied: !!isApplied,
          applicableProducts: []
        };
      });
      if (this.selectedCode?.length) {
        const selectedSet = new Set(this.selectedCode);
        const selectedVouchers = this.vouchers.filter(v => selectedSet.has(v.code));
        const otherVouchers = this.vouchers.filter(v => !selectedSet.has(v.code));

        selectedVouchers.sort(
          (a, b) =>
            this.selectedCode.indexOf(a.code) - this.selectedCode.indexOf(b.code)
        );

        this.vouchers = [...selectedVouchers, ...otherVouchers];
      }

      // this.vouchers.sort((a: any, b: any) => {
      //   if (a.code === 'GTT-Unlimited') return -1;
      //   if (b.code === 'GTT-Unlimited') return 1;
      //   return 0;
      // });
    },
    error: (error: any) => {
      console.log(error);
      this.appLoader = false;
    },
    complete: () => {
      this.appLoader = false;
    }
  });
}

  buyNow(voucher: Voucher) {
    const conditions = voucher.voucherCondition?.productQuantityConditions;
    if (!conditions?.length) return;

    const cartItems = (this.cart.items as any[]).map(item => ({
      ...item,
      SKU: item.SKU ?? item.sku,
    }));

    let allSatisfied = true;
    const itemsToUpdate = [];

    for (const cond of conditions) {
      const cartItem = cartItems.find(item => item.SKU === String(cond.sku));
      const currentQty = cartItem?.quantity ?? 0;
      const requiredQty = cond.quantity;

      if (currentQty < requiredQty) {
        allSatisfied = false;
        itemsToUpdate.push({
          sku: String(cond.sku),
          quantity: requiredQty,
          isSelected: true,
        });
      }
    }

    if (allSatisfied) {
      this.toastService.success('Bạn đã đủ số lượng sản phẩm để sử dụng mã giảm giá này !', '', {
        positionClass: 'toast-top-right',
      });
      return;
    }

    this.cartService.updateCartManyBySku(JSON.stringify({ items: itemsToUpdate })).subscribe({
      next: (res: any) => {
        this.cart = res;
        this.commonService.setCart(this.cart);
        this.toastService.success('Đã cập nhật giỏ hàng để thỏa mãn điều kiện mã giảm giá.', '', {
          positionClass: 'toast-top-right',
        });
      },
      error: (err) => {
        this.toastService.error(err.error.message, '', {
          positionClass: 'toast-top-right',
        });      },
    });
  }

  getApplicableVouchers(event: any) {
    this.params = event;
    this.getVouchers(this.params);
  }

  ngOnDestroy() {
    if (this.modalOpen) {
      this.modalService.dismissAll();
    }
  }
}
